import { useIsAuthenticated } from '../store/auth';
import useRestaurant from './useRestaurant';
import { useEffect } from 'react';
import { connect, disconnect } from '../services/aws';
import { getMQTTCredentials } from '../api/mqttCredentials';
import { showErrorToast } from '../services/toaster';
import i18n from '../localization/i18n';
import { reloadPage } from '../helpers/reloadPage';
import retryOnFailure from '../helpers/retryOnFailure';

const useMQTTConnection = () => {
    const restaurant = useRestaurant();
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        if (!isAuthenticated || !restaurant) {
            disconnect();
            return;
        }

        retryOnFailure(() =>
            getMQTTCredentials(restaurant.country_contact_information.code, restaurant.reference).then((mqttCredentials) => {
                connect(restaurant, mqttCredentials);
            })
        ).catch(() => {
            showErrorToast(i18n.t('orders.live_orders_messages.main.please_try_later'), {
                autoClose: false,
                ctaButtonText: i18n.t('orders.live_orders_messages.main.reload_page'),
                onCtaButtonClick: reloadPage,
                toastId: 'connection-error'
            });
        });
    }, [isAuthenticated, restaurant.id]);
};

export default useMQTTConnection;
